import { Link } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { PageHeader } from '../../components/PageHeader/PageHeader'
import { PageLoadingShell } from '../PageLoadingShell/PageLoadingShell'
import type { ListEntityPageProps } from './ListEntityPage.types'

export function ListEntityPage({
  title,
  description,
  loadingLabel,
  isLoading,
  error,
  createHref,
  createLabel = 'New',
  children,
}: ListEntityPageProps) {
  return (
    <>
      <PageHeader
        title={title}
        description={description}
        actions={
          createHref && (
            <Link
              to={createHref}
              className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1"
            >
              <Plus size={16} strokeWidth={2} aria-hidden="true" />
              {createLabel}
            </Link>
          )
        }
      />
      <PageLoadingShell
        loadingLabel={loadingLabel}
        isLoading={isLoading}
        error={error}
      >
        <section className="content-card" aria-label={title}>
          {children}
        </section>
      </PageLoadingShell>
    </>
  )
}
